import { useFormContext } from 'react-hook-form'
import { useSendFormFieldValidationEvent } from '@/scopes/checkout/domain/analytics/useSendParticipantsFormEvent'

export function useTrackFieldValidation(name: string) {
  const { formState, getFieldState } = useFormContext()
  const { error } = getFieldState(name, formState)
  useSendFormFieldValidationEvent(name, error)
}
